"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArticleBase = exports.articleBaseUseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
// we need to ignore the upcoming def because of tsc in apps compiling into this package
// eslint-disable-next-line
// @ts-ignore
exports.articleBaseUseableDef = {
    parent: undefined,
    validation: {
        ArticleType: true,
    },
};
exports.isArticleBase = echain_shared_modelling_1.UseableUtil.createGuard(exports.articleBaseUseableDef);
//# sourceMappingURL=ArticleBase.js.map